import React, { useState } from "react";
import { Form, Button, Table, Card, CardBody, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCircle, FaProjectDiagram, FaSearch, FaUser } from "react-icons/fa";
import GanttForView from "../GanttForView";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ResourcesAsigServices } from "./ResourcesAsigServices";

const AvailableResource = ({ resources }) => {
  const [selectedCriteria, setSelectedCriteria] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [dataResults, setDataResults] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [periodOfTime, setPeriodOfTime] = useState({})
  const [loading, setLoading] = useState(false);
  let { uid } = useParams();

  const handleSearch = async () => {
    try {
      setLoading(true);
      let date = selectedMonth.toISOString().split("T")[0].split("-");
      const data = {
        month_date: date[1],
        year_date: date[0],
        id_resource: selectedCriteria,
      };

      if (selectedCriteria.length > 0) {
        const result = await ResourcesAsigServices.getDataForTable(data);
        setDataResults(result.table);
        setDataTable(result.gantt);
        setPeriodOfTime(result.date)
      }
    } catch (error) {
      Swal.fire("Error", error, "error");
    } finally {
      setLoading(false);
      setSelectedMonth(new Date());
      setSelectedCriteria("");
    }
  };

  const Indicator = ({ cap, ocu, hideColor }) => {
    // Calcula el porcentaje. Si cap es 0 se evita la división.
    const percent = cap !== 0 ? parseFloat(((ocu / cap) * 100).toFixed(1)) : 0;

    // Variables para el color y el texto que se mostrarán según el porcentaje
    let color;
    let label;

    if (percent >= 0 && percent < 31) {
      color = "green";
      label = "Subutilizado";
    } else if (percent >= 31 && percent < 61) {
      color = "yellow";
      label = "Moderado";
    } else if (percent >= 61 && percent < 91) {
      color = "orange";
      label = "Alta ocupación";
    } else if (percent >= 91) {
      color = "red";
      label = "Sobreutilizado";
    } else {
      // Caso adicional para valores fuera de rango
      color = "gray";
      label = "Sin datos";
    }

    return (
      <div className="flex items-center">
        { hideColor ?  <span>
           ({percent}%)
        </span> : 
        <>
        <FaCircle color={color} style={{ marginRight: "8px" }} />
        {label}
        </>
         }
      </div>
    );
  };

  return (
    <>
      <Card className="shadow-sm mb-4">
        <Card.Header className="bg-light">
          <h5 className="mb-0">
            <FaUser size={16} className="mr-2 text-primary" />
            Recurso
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="d-flex gap-5">
            <Form.Select
              value={selectedCriteria}
              onChange={(e) => setSelectedCriteria(e.target.value)}
              className="shadow-sm form-control mr-2"
              style={{
                maxWidth: "250px",
                minWidth: "150px",
                borderRadius: "2px",
              }}
            >
              <option value="">-- Seleccionar --</option>
              {resources?.map((res) => (
                <option key={res.id} value={res.id}>
                  {res.text}
                </option>
              ))}
            </Form.Select>

            <DatePicker
              selected={selectedMonth}
              onChange={(date) => setSelectedMonth(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="form-control shadow-sm "
            />

            <Button
              className="ml-2"
              disabled={selectedCriteria.length > 0 ? false : true}
              variant="primary"
              onClick={handleSearch}
            >
              <FaSearch size={14} /> Buscar
            </Button>
          </div>
          {loading && (
            <div className="text-center mt-2">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {dataResults.length > 0 ? 
            
            <Table striped bordered hover className="mt-3" size="sm">
              <caption
                style={{"caption-side":"top",
                "padding": "10px",
                "font-weight": "bold"}}
              >
                Disponibilidad de {dataResults[0]?.Recurso} || periodo : {periodOfTime?.month}-{periodOfTime?.year}
              </caption>
              <thead>
                <tr>
                  <th>Proyectos</th>
                  <th>Actividades</th>
                  <th>Días Hábiles</th>
                  <th>Hrs Hábiles</th>
                  <th>Hrs Asignadas</th>
                  <th>Hrs Ejecutadas</th>
                  <th>Hrs Disponibles</th>
                  <th>Indicador</th>
                  <th>Ocupación</th>
                </tr>
              </thead>
              <tbody>
                {dataResults?.map((item, idx) => (
                  <tr key={idx}>
                    <td className="text-center">{item.CantProyectos}</td>
                    <td className="text-center">{item.CantActividades}</td>
                    <td className="text-center">{item.DiasHabiles}</td>
                    <td className="text-center">{item.HorasHabiles}</td>
                    <td className="text-center">{item.HorasAsignadas}</td>
                    <td className="text-center">{item.HorasEjecutadas}</td>
                    <td className="text-center">{item.HorasDisponibles}</td>
                    <td className="text-center">
                      <Indicator
                        cap={item.HorasHabiles}
                        ocu={item.HorasAsignadas}
                      />
                    </td>
                    <td className="text-center">
                      <Indicator
                        cap={item.HorasHabiles}
                        ocu={item.HorasAsignadas}
                        hideColor
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            :
            <>
            </>
          }
        </Card.Body>
      </Card>
      {dataTable.length > 0 ? 
        <Card className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <FaProjectDiagram size={16} className="mr-2 text-primary" />
              Timeline Recurso - {dataResults[0]?.Recurso} || Periodo : {periodOfTime?.month}-{periodOfTime?.year}
            </h5>
          </Card.Header>
          <Card.Body>
            <GanttForView uid={uid} available={true} data={dataTable} totalHours = {dataResults[0]?.HorasHabiles} />
          </Card.Body>
        </Card>
        :
        <>
          <div className="d-flex justify-content-center">
             <h6> El Recurso no tiene horas asignadas en el periodo de tiempo {periodOfTime?.month}-{periodOfTime?.year} </h6>      
          </div>
        </>
      }
    </>
  );
};

export default AvailableResource;
